import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MapPickerMode, MapPickerResult, MapPickerService } from '../../../services/mapPickerService-service';

@Component({
  selector: 'app-map-picker-button',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  template: `
    @if(mode=='search'){
       <div class="map-picker-button-wrapper">
      <button mat-stroked-button type="button" (click)="openPicker()">
        <mat-icon>location_on</mat-icon>
        {{ value ? editLabel : buttonLabel }}
      </button>

      <!-- <div class="map-picker-value" *ngIf="value">
        <small>{{ value.address || (value.lat + ', ' + value.lng) }}</small>
      </div> -->
    </div>
    }@else {
      <button mat-icon-button type="button" (click)="openPicker()">
        <mat-icon>location_on</mat-icon>
        <!-- {{ value ? editLabel : buttonLabel }} -->
      </button>
    }
  `,
  styles: [
    `
      .map-picker-button-wrapper {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
      }
      .map-picker-value {
        color: rgba(0, 0, 0, 0.6);
        max-width: 320px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    `,
  ],
})
export class MapPickerButtonComponent {
  @Input() mode: MapPickerMode = 'search';
  @Input() value?: MapPickerResult;
  @Input() buttonLabel = 'Seleccionar ubicación';
  @Input() editLabel = 'Cambiar ubicación';
  @Input() dialogTitle = 'Seleccionar ubicación';
  @Input() zoom = 16;

  @Output() valueChange = new EventEmitter<MapPickerResult>();
  @Output() selected = new EventEmitter<MapPickerResult>();

  constructor(private mapPickerService: MapPickerService) { }

  openPicker(): void {
    this.mapPickerService
      .open({
        mode: this.mode,
        lat: this.value?.lat,
        lng: this.value?.lng,
        address: this.value?.address,
        title: this.dialogTitle,
        zoom: this.zoom,
      })
      .subscribe((result) => {
        if (result) {
          this.value = result;
          this.valueChange.emit(result);
          this.selected.emit(result);
        }
      });
  }
}